(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/start-info-section/start-info-section.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/start-info-section/start-info-section.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui = svs.ui,
  _svs$ui$ReactCard = _svs$ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardGroup = _svs$ui$ReactCard.CardGroup,
  Button = _svs$ui.Button,
  ReactIcon = _svs$ui.ReactIcon;
const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const baseUrl = svs.core.data.baseUrl;
const Counter = _ref => {
  let data = _ref.data;
  const ref = React.useRef();
  const _React$useContext = React.useContext(svs.grassroots.context.Context),
    _React$useContext$cou = _React$useContext.countNumbers,
    countNumbers = _React$useContext$cou.countNumbers,
    setCountNumbers = _React$useContext$cou.setCountNumbers;
  const _React$useState = React.useState(data),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];

  React.useEffect(() => {
    if (countNumbers) {
      setValue(0);
      gsap.to(ref.current, {
        innerText: value,
        duration: 2,
        ease: 'power1.inOut',
        stagger: 0.1,
        modifiers: {
          innerText: innerText => gsap.utils.snap(1, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        }
      });
      setCountNumbers(false);
    }
  }, []);
  return React.createElement("h2", {
    className: "grassroots-start-info-counter-number",
    ref: ref
  }, value.toLocaleString('sv-SE'));
};
const onClickLoginAndSearch = e => {
  e && e.preventDefault();
  svs.components.customer_login.login({
    returnUrl: "".concat(svs.core.data.baseUrl, "/sok")
  });
};
const StartInfoSection = () => {
  const _grassrootsQueryApi$u = grassrootsQueryApi.useFetchStatisticsQuery(),
    data = _grassrootsQueryApi$u.data;
  return React.createElement("div", {
    className: "grassroots-start-info-background-container"
  }, React.createElement("div", {
    className: "grassroots-start-info-container"
  }, React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "align-center grassroots-start-info-card-container"
  }, React.createElement(CardBody, null, React.createElement("h1", null, svs.grassroots_shared_2.data.config.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.ingress), React.createElement("div", {
    className: "grid-row grassroots-start-info-counter-container"
  }, React.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, (data === null || data === void 0 ? void 0 : data.receiverCount) && React.createElement("div", null, React.createElement(Counter, {
    data: data.receiverCount
  }), React.createElement("h3", {
    className: "f-medium grassroots-start-info-counter-type"
  }, svs.grassroots_shared_2.data.config.receivers))), React.createElement("div", {
    className: "col-xs-12 col-sm-6"
  }, (data === null || data === void 0 ? void 0 : data.supporterCount) && React.createElement("div", null, React.createElement(Counter, {
    data: data.supporterCount
  }), React.createElement("h3", {
    className: "f-medium grassroots-start-info-counter-type"
  }, svs.grassroots_shared_2.data.config.supporters))), React.createElement("div", {
    className: "col-xs-12"
  }, !svs.grassroots_shared_2.data.config.isCorporateSite && React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    iconPosition: "right",
    inverted: true,
    onClick: onClickLoginAndSearch
  }, "St\xF6tta din f\xF6rening"))))), svs.grassroots_shared_2.data.config.isCorporateSite && React.createElement(CardGroup, {
    className: "grassroots-start-info-corporate-container align-center"
  }, React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "padding-1 grassroots-start-info-corporate-marketing"
  }, React.createElement(CardBody, {
    className: "u-flex u-flex-column"
  }, React.createElement("h3", {
    className: "grassroots-start-info-corporate-marketing-title"
  }, svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.description), React.createElement(Button, {
    block: true,
    className: "grassroots-start-info-corporate-button",
    href: svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.buttonPath,
    iconPosition: "right",
    inverted: true
  }, React.createElement(ReactIcon, {
    icon: "link-external"
  }), ' ', svs.grassroots_shared_2.data.config.grassrootsPartnerMarketing.marketing.buttonText))), React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "padding-1 grassroots-start-info-corporate-supporter"
  }, React.createElement(CardBody, {
    className: "u-flex u-flex-column"
  }, React.createElement("h3", {
    className: "grassroots-start-info-corporate-supporter-title"
  }, svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.title), React.createElement("p", null, svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.description), React.createElement(Button, {
    block: true,
    className: "grassroots-start-info-corporate-button",
    href: baseUrl + svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.buttonPath,
    inverted: true
  }, svs.grassroots_shared_2.data.config.grassrootsSupporter.supporter.buttonText))))));
};
svs.grassroots.components.start_info_section.StartInfoSection = StartInfoSection;

 })(window);